import React, { useEffect, useState } from "react";
import { FormControl, MenuItem, TextField, Button, Select, InputLabel } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import adminService from "../../Services/adminService";
import { uploadToAws } from "../../Services/awsService";
import Swal from "sweetalert2";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

const CONSTANTS = [
  { name: "Btax", src: "https://practicum-classes.s3.eu-central-1.amazonaws.com/logo-btax.png" },
  { name: "Practicum", src: "https://practicum-classes.s3.eu-central-1.amazonaws.com/logo-practicum.png" },
  {
    name: "Assessor",
    src: "https://practicum-classes.s3.eu-central-1.amazonaws.com/logo-assessor.png"
  }
];

const AdminUploadEpisodes = (props) => {
  const [videoDetails, setVideoDetails] = useState({
    isActive: "yes"
  });
  const [selectedFile, setSelectedFile] = useState(null);

  const courseTitles = props.courses.map((course) => course.title);

  useEffect(() => {
    if (props.editMode) {
      setVideoDetails(props.videoDetails);
    }
  }, []);

  return (
    <div className="upload-video-container">
      <h3 className="mt-30 mb-50">{props.editMode ? "ערוך פרק" : "העלה פרק"}</h3>
      <div className="flex flex-direction-column bg-white bordered">
        {props.editMode && <div className="center my-20">{videoDetails.id}</div>}
        <div className="flex justify-center">
          <TextField
            style={{ marginTop: "10px", width: "550px" }}
            label="שם הפרק"
            value={videoDetails.title || ""}
            onChange={(e) => onChange("title", e.target.value)}
          />
        </div>
        <div className="flex justify-center">
          <Autocomplete
            style={{ marginTop: "10px", width: "550px" }}
            options={courseTitles}
            getOptionLabel={(option) => option}
            value={videoDetails.course || ""}
            onChange={(e, val) => onChange("course", val)}
            renderInput={(params) => <TextField {...params} label="שם קורס" />}
          />
        </div>
        <div className="flex justify-center align-flex-end">
          <FormControl style={{ marginTop: "20px", width: "550px" }}>
            <InputLabel>בחר לוגו</InputLabel>
            <Select value={videoDetails.logos || []} multiple onChange={(e) => onChange("logos", e.target.value)}>
              {CONSTANTS.map((logo) => {
                return (
                  <MenuItem key={logo.name} value={logo.name}>
                    {logo.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
        <div className="flex justify-center">
          <div style={{ marginTop: "10px", width: "550px" }}>
            <input
              accept="video/*"
              style={{ display: "none" }}
              id="video-file-upload"
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setSelectedFile(file);
                  onChange("fileName", file.name);
                }
              }}
            />
            <label htmlFor="video-file-upload">
              <Button
                variant="outlined"
                component="span"
                startIcon={<CloudUploadIcon style={{ marginLeft: "12px" }} />}
                style={{ width: "100%", height: "56px" }}
              >
                {selectedFile ? selectedFile.name : "בחר קובץ וידאו להעלאה"}
              </Button>
            </label>
          </div>
        </div>
        <div className="flex justify-center align-flex-end">
          <FormControl style={{ marginTop: "20px", width: "550px" }}>
            <InputLabel>האם פעיל</InputLabel>
            <Select value={videoDetails.isActive || "yes"} onChange={(e) => onChange("isActive", e.target.value)}>
              <MenuItem value="yes">פעיל</MenuItem>
              <MenuItem value="no">לא פעיל</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="mt-20 mb-10 flex justify-center">
          נסגר בתאריך:
          <input onChange={(e) => onChange("validUntilDate", e.target.value)} type="date" value={videoDetails.validUntilDate} />
        </div>
        <div className="mt-20 mb-10 flex justify-center">
          <Button color="primary" variant="contained" onClick={props.editMode ? updateEpisode : uploadEpisode}>
            {props.editMode ? "עדכון" : "העלה"}
          </Button>
        </div>
      </div>
    </div>
  );

  async function uploadEpisode() {
    if (!videoDetails.course) return Swal.fire("אנא בחר קורס", "", "warning");
    if (!selectedFile) return Swal.fire("אנא בחר קובץ וידאו", "", "warning");

    try {
      // First, upload to AWS and get the URL
      const fileAccessUrl = await uploadToAws(selectedFile, videoDetails.title);
      if (!fileAccessUrl) {
        throw new Error("Failed to get file URL from AWS");
      }

      // Only if AWS upload succeeds, proceed with episode creation
      const courseId = props.courses.find((course) => course.title === videoDetails.course)._id;

      const episodeData = {
        ...videoDetails,
        link: fileAccessUrl,
        belongToCourseId: courseId
      };
      delete episodeData.course;

      const res = await adminService.uploadEpisodes(episodeData);

      if (res.success) {
        Swal.fire("הסרטון עלה בהצלחה", "", "success");
        setVideoDetails({});
        setSelectedFile(null);
      } else {
        throw new Error("Failed to create episode");
      }
    } catch (err) {
      console.error(err);
      if (err.message === "Failed to get file URL from AWS") {
        Swal.fire("שגיאה בהעלאת הקובץ לAWS", "", "error");
      } else {
        Swal.fire("שגיאה ביצירת הפרק", "", "error");
      }
    }
  }

  async function updateEpisode() {
    try {
      const courseId = props.courses.find((course) => course.title === videoDetails.course)._id;
      videoDetails.belongToCourseId = courseId;
      delete videoDetails.course;
      const res = await adminService.updateEpisode(videoDetails);
      if (res.success) Swal.fire("הסרטון מעודכן", "", "success");
    } catch (err) {
      console.log(err);
    }
  }

  function onChange(type, value) {
    const oldData = { ...videoDetails };
    oldData[type] = value;
    setVideoDetails(oldData);
  }
};

export default AdminUploadEpisodes;
